/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailReference_viewer = {
    readonly isItemInvoiceEnabled: boolean | null;
    readonly " $refType": "PdpSharedDetailReference_viewer";
};
export type PdpSharedDetailReference_viewer$data = PdpSharedDetailReference_viewer;
export type PdpSharedDetailReference_viewer$key = {
    readonly " $data"?: PdpSharedDetailReference_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailReference_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailReference_viewer",
  "selections": [
    {
      "alias": "isItemInvoiceEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "INVOICE"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"INVOICE\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '0e28fc50ce37d3cf6e5dff753ecc8480';
export default node;
